import { render, staticRenderFns } from "./StrategyItem.vue?vue&type=template&id=3ecd1f13&lang=pug"
import script from "./StrategyItem.vue?vue&type=script&lang=js"
export * from "./StrategyItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports